module.exports =
  'auction-faqs':
    title: 'Auction FAQs'
    description: '
      How can we help you? Below are a few general categories to help you find the answers you’re looking for.\n\n
      Need more immediate assistance? Please [contact us](mailto:specialist@artsy.net)
    '
    pages:
      'Bidding': 'how-auctions-work-bidding'
      'Buyers premium, taxes, & fees': 'how-auctions-work-buyers-premium-taxes-and-fees'
      'Payments and Shipping': 'how-auctions-work-payments-and-shipping'
      'Emails and alerts': 'how-auctions-work-emails-and-alerts'
      'Conditions of sale': 'how-auctions-work-conditions-of-sale'
  'collector-faqs':
    title: 'Collector FAQs'
    description: '
      How can we help you? Below are answers to some of the most common questions from collectors.\n\n
      Need more immediate assistance? Please [contact us](mailto:support@artsy.net)
    '
    pages:
      'Buying on Artsy': 'collector-faqs-buying-on-artsy'
      'Exploring Artsy': 'collector-faqs-exploring-artsy'
      'Selling On Artsy': 'collector-faqs-selling-on-artsy'

  'artist-faqs':
    title: 'Artist FAQs'
    description: '
      How can we help you? Below are answers to some of the most common questions from artists.\n\n
    '
    pages:
      'How Artsy Works': 'artist-faqs-how-artsy-works'
      'Listing Artworks': 'artist-faqs-listing-artworks'
      'Other Requests': 'artist-faqs-other-requests'

  'consignment-faqs':
    title: 'Consignment FAQs'
    description: ''
    pages:
      'Overview': 'consignments-faq-overview'
      'Fees & Estimates': 'consignments-faq-fees-and-estimates'
      'Consignment Agreement': 'consignments-faq-consignment-agreement'
